import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCastle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCastle"><Path d="M16.5 3.5H19.5V5.5L20.5 20.5H14.5V15.5H9.5V20.5H3.5L4.5 5.5V3.5H7.5V5.5H10.5V3.5H13.5V5.5H16.5V3.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCastle;
